/**
 * 深度优先遍历对象/成员含有对象的数组
 * @param source
 * @param fn
 */
export function iterateObjDeep(source: Record<any, any> | any[], fn: (obj: Record<any, any>) => any) {
  if (Array.isArray(source)) {
    source.forEach((item) => {
      if (Object.prototype.toString.call(item) === '[object Object]') {
        fn(item);
        Object.values(source).forEach((item2) => {
          iterateObjDeep(item2, fn);
        });
      }
    });
  } else if (Object.prototype.toString.call(source) === '[object Object]') {
    fn(source);
    Object.values(source).forEach((item) => {
      iterateObjDeep(item, fn);
    });
  }
}

/**
 * 广度优先遍历对象/成员含有对象的数组
 * @param source
 * @param fn
 */
export function iterateObjDeepBFS(source: Record<any, any> | any[], fn: (obj: Record<any, any>) => any) {
  const repeatSet = new Set<Record<any, any>>();
  const queue: Record<any, any>[] = [];

  if (Array.isArray(source)) {
    queue.push(...source);
  } else if (Object.prototype.toString.call(source) === '[object Object]') {
    queue.push(source);
  } else {
    return;
  }

  while (queue.length > 0) {
    const curNode = queue.shift();

    if (!curNode || repeatSet.has(curNode)) {
      continue;
    }
    repeatSet.add(curNode);
    fn(curNode);

    Object.values(curNode).forEach((val) => {
      if (Array.isArray(val)) {
        queue.push(...val);
      } else if (Object.prototype.toString.call(val) === '[object Object]') {
        queue.push(val);
      }
    });
  }
}

/**
 * 设置对象的属性值，支持多级属性，支持基础数据类型和引用数据类型
 *
 * @export
 * @param {Record<any, any>} obj
 * @param {*} value
 * @param {string} key
 */
export function setObjValue(obj: Record<any, any>, value: any, key?: string) {
  if (!key) {
    Object.assign(obj, value);
    return;
  }

  const keys = key.split('.');
  let curObj = obj;
  const valueIsObject = Object.prototype.toString.call(value) === '[object Object]';
  const len = valueIsObject ? keys.length : keys.length - 1;
  for (let i = 0; i < len; i++) {
    if (!curObj[keys[i]]) {
      curObj[keys[i]] = {};
    }
    curObj = curObj[keys[i]];
  }

  if (valueIsObject) {
    Object.assign(curObj, value);
  } else {
    curObj[keys[keys.length - 1]] = value;
  }
}
